<template>
<v-container class="d-flex align-center justify-center" fluid>
    <!-- Loading Screen -->
    <div v-if="loading" class="loading-container">
      <v-row justify="center" align="center" style="height: 100vh;">
        <v-col cols="auto" class="text-center">
          <v-progress-circular indeterminate color="primary" size="64" />
          <p class="mt-4 text-subtitle-1 font-italic">Getting things ready for you...</p>
        </v-col>
      </v-row>
    </div>

    <div v-else>
      <!-- Branding Section -->
      <v-row justify="center" class="text-center mb-6">
        <v-col cols="12">
          <v-img src="assets/logo.png" contain max-height="100" class="mb-4" />
          <h2 class="font-weight-bold">FileFlow</h2>
          <p class="text-grey--text text-subtitle-2">Stay organized, stay efficient</p>
          <v-btn color="primary" class="mr-2" href="/signup">Sign Up</v-btn>
          <v-btn outlined color="primary" href="/login">Login</v-btn>
          <div class="mt-4">
            <v-btn text small color="grey" href="/forgot-password">Forgot your password?</v-btn>
          </div>
        </v-col>
      </v-row>

      <!-- Dashboard Section -->
      <v-card class="mb-4">
        <v-card-title>👋 Hello, {{ userName }}</v-card-title>
        <v-card-text>
          <p>Today’s Transfers</p>
          <v-row>
            <v-col><strong>Sent:</strong> {{ sentFiles }} files</v-col>
            <v-col><strong>Received:</strong> {{ receivedFiles }} files</v-col>
          </v-row>
          <v-btn small outlined color="secondary" href="/details">Details</v-btn>
        </v-card-text>
      </v-card>

      <!-- Progress Section -->
      <v-card class="mb-4">
        <v-card-title>Transfer Progress</v-card-title>
        <v-card-text>
          <v-progress-linear :value="transferProgress" color="primary" height="6">
            <template v-slot:default>
              <span>{{ transferProgress }}%</span>
            </template>
          </v-progress-linear>
          <div class="text-center mt-4">
            <v-btn small outlined color="primary" href="/upload">Upload</v-btn>
            <v-btn small outlined color="primary" href="/download">Download</v-btn>
          </div>
        </v-card-text>
      </v-card>

      <!-- Recent Activity Section -->
      <v-card>
        <v-card-title>Recent Activity</v-card-title>
        <v-list>
          <v-list-item v-for="(activity, index) in recentActivities" :key="index">
            <v-list-item-icon>
              <v-icon>{{ activity.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              {{ activity.message }}
              <div class="text-caption text-grey--text">{{ activity.time }}</div>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'HomeView',
  data() {
    return {
      loading: true,
      userName: 'Alex',
      sentFiles: 3,
      receivedFiles: 2,
      transferProgress: 75,
      recentActivities: [
        { icon: 'mdi-folder-send', message: "Sent 'report.pdf' to John", time: '2 hours ago' },
        { icon: 'mdi-download', message: "Received 'photo.zip' from Alice", time: '1 hour ago' },
        { icon: 'mdi-folder-send', message: "Sent 'presentation.pptx' to Emma", time: '30 minutes ago' }
      ]
    }
  },
  mounted() {
    setTimeout(() => {
      this.loading = false
    }, 333) // Simulate loading delay
  }
}
</script>

<style scoped>
.loading-container {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
